<div class="settings-page">
    <div class="settings-page__content">
        <div class="settings-card">
            <div class="settings-card__header">
                <img src="/assets/images/Group 24.svg" alt="" />
                <div class="settings-card__header-headline">
                    <h2>Bine ați venit!</h2>
                    <h4>Setări - Beneficiari</h4>
                </div>
            </div>
        </div>
    </div>

    <div class="content-box">
        <div class="settings-page-container">
            <mat-button-toggle-group [value]="selectedComponent" (change)="onChange($event)" class="settings-page_menu">
                <mat-button-toggle [value]="option" class="settings-page_menu-item"
                    *ngFor="let option of componentKeys">
                    <div style="text-align: left;">
                        {{ option }}
                    </div>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="settings-page__content">
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.SITUATIE_CURENTA_COPIL">
                <app-situatie-curenta></app-situatie-curenta>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.GRUP_ATRIBUTE_COPII">
                <app-grup-atribute></app-grup-atribute>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.ATRIBUTE_COPII">
                <app-atribute-copii></app-atribute-copii>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.TIPURI_DATE_COPII">
                <app-tipuri-date></app-tipuri-date>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.STATUS_EVENIMENT_COPIL">
                <app-status-eveniment></app-status-eveniment>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.PRIORITATE_EVENIMENT_COPIL">
                <app-prioritate-eveniment></app-prioritate-eveniment>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.ENTITATE_INRUDITA_TYPE">
                <app-entitate-inrudita-type></app-entitate-inrudita-type>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.RELATIE_TYPE">
                <app-relatie-type></app-relatie-type>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.CUSTODIE_TYPE">
                <app-custodie-type></app-custodie-type>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.RELATIE_STATUS">
                <app-relatie-status></app-relatie-status>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.CAPACITATE_CRESTERE_COPIL">
                <app-capacitate-crestere></app-capacitate-crestere>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.NIVEL_RISC">
                <app-nivel-risc></app-nivel-risc>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.STATUS_LEGAL">
                <app-status-legal></app-status-legal>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.CONTACT_FRECVENTA">
                <app-contact-frecventa></app-contact-frecventa>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.PARTEA_RELATIEI">
                <app-partea-relatiei></app-partea-relatiei>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.RELATIE_SPECIFICA_SEX">
                <app-relatie-specifica></app-relatie-specifica>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.CONFIRMARE_RELATIE">
                <app-confirmare-relatie></app-confirmare-relatie>
            </ng-container>
            <ng-container *ngIf="selectedComponent === SettingsActivitiesOption.ADRESE_CENTRE">
                <app-adrese-centre></app-adrese-centre>
            </ng-container>
            <div class="row" *ngIf="selectedComponent == null">
                <div class="col-sm-12 py-5">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="col-12 text-center">
                            <div class="py-3">
                                <p class="mb-0">Selectați o secțiune</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>